<template>
    <div class="ide-container">
      <div class="editor-panel">
        <div class="editor-toolbar">
          <div class="toolbar-left">
            <button @click="saveToFile" class="action-btn save-btn">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                <polyline points="17 21 17 13 7 13 7 21"/>
                <polyline points="7 3 7 8 15 8"/>
              </svg>
              <span>保存</span>
            </button>
          </div>
          
          <div class="toolbar-center" v-if="language === 'java'">
            <div class="input-wrapper">
              <input v-model="stdin" placeholder="输入内容 (stdin)"/>
            </div>
          </div>
          
          <div class="toolbar-right">
            <div class="connection-status">
              <span :class="['status-dot', connected ? 'connected' : 'disconnected']"></span>
              <span class="status-text">{{ connected ? '已连接' : '未连接' }}</span>
            </div>
          </div>
        </div>
        
        <div class="editor-wrapper">
          <editor 
            v-model="code" 
            lang="java" 
            theme="chrome" 
            class="editor"
            ref="aceEditor" 
            id="codeEditor"
            :options="editorOptions"
            @paste="handlePaste"
          ></editor>
          
          <div class="action-buttons" v-if="editorOptions.showGutter">
            <div class="status-indicator">
              <img v-if="result === 1" src="/images/right.png" class="status-icon success"/>
              <img v-if="result === 0" src="/images/error.png" class="status-icon error"/>
            </div>
            <button 
              class="btn btn-primary btn-run" 
              @click="run" 
              :disabled="running"
            >
              <span>{{ running ? '⏳' : '▶️' }}</span>
              <span>{{ running ? '运行中...' : '运行' }}</span>
            </button>
            <button class="btn btn-outline" @click="stop">
              <span>⏹️</span>
              <span>停止</span>
            </button>
          </div>
        </div>
        
        <div class="result-panel" v-if="resultText != null">
          <div class="result-header">
            <span class="result-title">运行结果</span>
            <button class="close-btn" @click="resultText = null">✕</button>
          </div>
          <div class="result-content" v-html="resultText"></div>
        </div>
      </div>

      <div class="sidebar">
        <div class="canvas-section">
          <div class="canvas-header">
            <span class="canvas-title">🎨 画布</span>
          </div>
          <div class="canvas-wrapper">
            <canvas ref="canvas" id="myCanvas"></canvas>
          </div>
        </div>
        
        <div class="tabs-section">
          <div class="tabs">
            <button 
              :class="['tab-btn', { active: tab === 'basic' }]" 
              @click="switchTab('basic')"
            >
              基础课
            </button>
            <button 
              :class="['tab-btn', { active: tab === 'exam' }]" 
              @click="switchTab('exam')"
            >
              基础练习
            </button>
          </div>
          
          <div class="sidebar-content">
            <div class="course-list" v-if="tab === 'basic'">
              <div 
                v-for="(c, index) in classes" 
                :key="'cl-'+index"
                class="course-item"
              >
                <div class="course-header" @click.stop="openClass(c)">
                  <span class="course-name">{{ c.name }}</span>
                  <span class="course-toggle">
                    <img :src="c.open ? '/images/close.png' : '/images/open.png'" alt="toggle"/>
                  </span>
                </div>
                
                <div v-if="c.open" class="topic-list">
                  <div 
                    v-for="(s, index1) in c.topic" 
                    :key="'cl-'+index+'-'+index1"
                    class="topic-item"
                    @click="loadProject(s)"
                  >
                    <span class="topic-number">{{ index1 + 1 }}.</span>
                    <span class="topic-name">{{ s.name }}</span>
                    <span class="topic-action">
                      <img src="/images/code.png" alt="code"/>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="course-list" v-if="tab === 'exam'">
              <div 
                v-for="(c, index) in exam" 
                :key="'ex-'+index"
                class="course-item"
              >
                <div class="course-header" @click.stop="openClass(c)">
                  <span class="course-name">{{ c.name }}</span>
                  <span class="course-toggle">
                    <img :src="c.open ? '/images/close.png' : '/images/open.png'" alt="toggle"/>
                  </span>
                </div>
                
                <div v-if="c.open" class="topic-list">
                  <div 
                    v-for="(s, index1) in c.topic" 
                    :key="'ex-'+index+'-'+index1"
                    class="topic-item"
                    @click="loadProjectDirect(s)"
                  >
                    <span class="topic-number">{{ index1 + 1 }}.</span>
                    <span class="topic-name">{{ s.name }}</span>
                    <span class="topic-action">
                      <img src="/images/code.png" alt="code"/>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="error-layer" v-if="error != null">
        {{ error }}
      </div>
    </div>
</template>

<script>
import editor from 'vue2-ace-editor'
import bus from '../utils/bus';
import util from '../utils/util';
require('brace/mode/java');
require('brace/theme/chrome');

export default {
  data() {
    return {
      code: "void setup(){\n\tsize(800,600);\n}",
      processing: null,
      projects:[],
      classes:[],
      advanced:[],
      exam:[],
      advancedexam:[],
      tab:"basic",
      connected:false,
      language:'processing',
      stdin:"",
      running:false,
      editorOptions: {
        enableBasicAutocompletion: false,
        enableLiveAutocompletion: false,
        enableSnippets: false,
        enableLinking: false,
        foldStyle: 'manual',
        showGutter:true,
      },
      socket:null,
      loopCheck:true,
      result:-1,
      error:null,
      lastLength:0,
      resultText:null,
    };
  },
  components:{
    editor
  },
  mounted() {
    this.loadList();
    this.connectLoop();

    console.log(document.getElementById("myCanvas"));

    bus.$on('login',()=>{
      this.loadList();
      this.connectServer();
    })

    bus.$on('logout',()=>{
      this.projects = [];
      this.classes = [];
    })

    setTimeout( ()=>{
      document.getElementsByClassName("ace_text-input")[0].addEventListener('paste', this.handlePaste);
    },500);
  },
  methods: {
    saveToFile(){
      const content = this.code;
      const blob = new Blob([content], { type: 'text/plain' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'code.txt';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    },
    connectLoop(){
      var mobile = util.getSearchString("user");
      var target = util.getSearchString("target");
      if(target == null || target == ""){
        target = "patrick";
      }

      if(mobile != null && mobile != ""){
        if(!this.connected){
          this.connectServer();
        }

        var interval = setInterval( ()=>{
          if(!this.connected){
            this.connectServer();
          }
          else{
            clearInterval(interval);
          }
        },5000);
        
      }
    },
    handlePaste(){
      if(this.socket != null){
        var mobile = util.getSearchString("user");
        var target = util.getSearchString("target");
        if(target == null || target == ""){
        target = "patrick";
      }

        if(mobile == null || mobile == ""){
            return;
        }
        var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
          try{
            this.socket.send(sendStr);
          }
          catch( err){
          }
      }
    },
    connectServer(){
      var mobile = util.getSearchString("user");
      var target = util.getSearchString("target");

      if(mobile == null || mobile == ""){
          return;
      }

      if(target == null || target == ""){
        target = "patrick";
      }
      
      const socket = new WebSocket('wss://wss.dctechonline.cn:8024');

      this.socket = socket;

      socket.addEventListener('open', event1 => {
        console.log('WebSocket connection established.');
        
        socket.send(JSON.stringify(
          {
              type:"user",
              mobile:mobile,
              target:target
          }));

          var interval2 = setInterval( ()=>{
            if(this.loopCheck == false){
              clearInterval(interval2);
              this.connected = false;
              this.connectLoop();
              return;
            }
            else{
              socket.send(JSON.stringify(
              {
                  type:"loopcheck",
                  mobile:mobile
              }))
              this.loopCheck = false;
              console.log('check successful');
            }
          },20000);

          this.connected = true;

          socket.addEventListener('message', event => {
          const reader = new FileReader();
          reader.addEventListener('loadend', () => {
            const text = reader.result;
            const data = JSON.parse(text);
            const { type, value,from } = data;
            console.log(data);
            if (type === 'classcode' && from == target) {
              this.code = value;
            }
            else if(type ==="loopcheck"){
              this.loopCheck = true;
            }
          });
          reader.readAsText(event.data);
        });

          this.$refs.aceEditor.$vnode.elm.children[0].addEventListener('input', event => {
          var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
          try{
            socket.send(sendStr);
          }
          catch( err){
          }
        });
      });
    },
    openClass(c){
      if(c.open){
        c.open = false;
      }
      else{
        c.open = true;
      }
    },
    switchTab(tab){
      this.tab = tab;
    },
    loadList(){
      var r = new Date().getTime();
      this.$http.get("/data/exam.json?random="+r).then(response => {
        this.exam = response.data;
      });

      this.$http.get("/data/classes.json?random="+r).then(response => {
        this.classes = response.data;
      });

      this.$http.get("/data/advanced.json?random="+r).then(response => {
        this.advanced = response.data;
      });

      this.$http.get("/data/advancedexam.json?random="+r).then(response => {
        this.advancedexam = response.data;
      });
    },
    changeLanguage(e){
        this.code = "";
        this.resultText = null;
    },
    loadProject(p){
       this.resultText = null;
        if(p.language){
          this.language = p.language;
        }
        else{
          this.language = 'processing';
        }
        var r = new Date().getTime();
        this.$http.get(p.path+"?random="+r, { responseType: 'arraybuffer' }).then(response => {
          const decoder = new TextDecoder('utf-8');
          const content = decoder.decode(response.data);
          this.code = content;
        }).catch(error => {
        });
    },
    loadProjectDirect(p){
      this.resultText = null;
        if(p.language){
          this.language = p.language;
        }
        else{
          this.language = 'processing';
        }
        var r = new Date().getTime();
        this.$http.get(p.path+"?random="+r, { responseType: 'arraybuffer' }).then(response => {
          console.log(response.data);
          const decoder = new TextDecoder('utf-8');
          const content = decoder.decode(response.data);
          this.code = content;
        }).catch(error => {
        });
    },
    run() {
      if(this.running){
          return;
      }

      this.running = true;
      if(this.language == 'processing'){
        this.result = -1;
        this.error = null;
        if(this.processing != null){
          this.processing.exit();
          this.processing = null;
        }

        var elements1 = document.getElementsByClassName("ace_gutter-cell");
        for(var i=0;i<elements1.length;i++){
          elements1[i].className = "ace_gutter-cell";
        }

        this.running = false;
        try{
          this.processing = new Processing(this.$refs.canvas, this.code);
          console.log(this.processing)
          this.result = 1;
        }
        catch(err){
          this.result = 0;
          this.error = err;
        } 
      }
      else{
        this.result = -1;
        this.resultText = null;
        var postInfo = {};
          postInfo.code = encodeURIComponent(this.code);
          postInfo.language = 8;
          postInfo.stdin = this.stdin;
          postInfo.fileext = "java";

          this.$http.post("https://aiapi.dctechonline.cn/api/runcode",postInfo).then(response => {
            console.log(response.data);
            this.running = false;
            this.resultText = response.data.output != '' ? response.data.output.replace(/\n/g, '<br>') : response.data.errors.replace(/\n/g, '<br>')
          });
      }
    },
    stop() {
      this.code = "";
      this.result = -1;
      this.error = null;
      this.processing.exit();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';
@import '../styles/mixins.scss';

.ide-container {
  position: fixed;
  top: 64px;
  left: 0;
  width: 100%;
  height: calc(100vh - 64px);
  display: flex;
  background: $bg-secondary;
}

.editor-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  background: #fafafa;
}

.editor-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: white;
  border-bottom: 1px solid $border-color;
  gap: 20px;
}

.toolbar-left {
  display: flex;
  align-items: center;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: all $transition;
  border: none;
  
  svg {
    width: 16px;
    height: 16px;
  }
  
  &.save-btn {
    background: rgba($primary-color, 0.1);
    color: $primary-color;
    
    &:hover {
      background: rgba($primary-color, 0.15);
    }
  }
}

.toolbar-center {
  flex: 1;
  max-width: 400px;
}

.input-wrapper {
  input {
    width: 100%;
    padding: 8px 16px;
    border: 1px solid $border-color;
    border-radius: $border-radius;
    font-size: 13px;
    transition: all $transition-fast;
    
    &:focus {
      outline: none;
      border-color: $primary-color;
      box-shadow: 0 0 0 3px rgba($primary-color, 0.1);
    }
    
    &::placeholder {
      color: $text-muted;
    }
  }
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  
  &.connected {
    background: $success-color;
    box-shadow: 0 0 8px rgba($success-color, 0.5);
  }
  
  &.disconnected {
    background: $danger-color;
    box-shadow: 0 0 8px rgba($danger-color, 0.5);
  }
}

.status-text {
  font-size: 12px;
  color: $text-secondary;
}

.editor-wrapper {
  flex: 1;
  overflow: hidden;
  position: relative;
}

.editor {
  width: 100%;
  height: 100%;
  background: white !important;
  font-size: 14px !important;
  
  :deep(.ace_print-margin) {
    display: none;
  }
  
  :deep(.ace_gutter) {
    background: #f8f9fa !important;
  }
  
  :deep(.ace_identifier) {
    color: #1890ff;
  }
  
  :deep(.ace_numeric) {
    color: #52c41a !important;
  }
  
  :deep(.ace_keyword) {
    color: #722ed1 !important;
  }
  
  :deep(.ace_string) {
    color: #fa8c16 !important;
  }
  
  :deep(.ace_comment) {
    color: #8c8c8c !important;
    font-style: italic;
  }
  
  :deep(.ace_function) {
    color: #13c2c2 !important;
  }
}

.result-panel {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  max-height: 200px;
  background: #2d3748;
  border-top: 1px solid #4a5568;
  z-index: 10;
}

.result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #1a202c;
  border-bottom: 1px solid #4a5568;
}

.result-title {
  font-size: 13px;
  font-weight: 500;
  color: #e2e8f0;
}

.close-btn {
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: #a0aec0;
  font-size: 16px;
  cursor: pointer;
  border-radius: $border-radius-sm;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all $transition-fast;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }
}

.result-content {
  padding: 16px;
  font-family: $font-family-mono;
  font-size: 13px;
  color: #e2e8f0;
  line-height: 1.6;
  overflow: auto;
  max-height: 140px;
  
  @include scroll-style;
}

.sidebar {
  width: 480px;
  background: white;
  border-left: 1px solid $border-color;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  
  @include responsive(lg) {
    width: 260px;
  }
  
  @include responsive(md) {
    width: 240px;
  }
}

.canvas-section {
  height: 45%;
  border-bottom: 1px solid $border-color;
  display: flex;
  flex-direction: column;
}

.canvas-header {
  padding: 12px 16px;
  border-bottom: 1px solid $border-color;
  background: $bg-secondary;
}

.canvas-title {
  font-size: 14px;
  font-weight: 600;
  color: $text-primary;
}

.canvas-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  overflow: hidden;
  
  canvas {
    max-width: 100%;
    max-height: 100%;
  }
}

.tabs-section {
  height: 55%;
  display: flex;
  flex-direction: column;
}

.tabs {
  display: flex;
  background: $bg-secondary;
  border-bottom: 1px solid $border-color;
  flex-shrink: 0;
}

.tab-btn {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px 8px;
  font-size: 12px;
  font-weight: 500;
  color: $text-secondary;
  cursor: pointer;
  border: none;
  background: transparent;
  border-bottom: 2px solid transparent;
  transition: all $transition;
  
  &:hover {
    color: $primary-color;
    background: rgba($primary-color, 0.05);
  }
  
  &.active {
    color: $primary-color;
    background: white;
    border-bottom-color: $primary-color;
  }
}

.sidebar-content {
  flex: 1;
  overflow-y: auto;
  
  @include scroll-style;
}

.course-list {
  padding: 0;
}

.course-item {
  border-bottom: 1px solid $border-color;
}

.course-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  font-size: 14px;
  font-weight: 600;
  color: $text-primary;
  cursor: pointer;
  transition: all $transition-fast;
  
  &:hover {
    background: rgba($primary-color, 0.05);
    padding-left: 20px;
  }
  
  .course-name {
    flex: 1;
  }
  
  .course-toggle img {
    width: 16px;
    height: 16px;
    opacity: 0.5;
    transition: transform 0.3s ease;
  }
}

.topic-list {
  background: $bg-secondary;
  padding: 4px 0;
}

.topic-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px 10px 24px;
  font-size: 13px;
  color: $text-secondary;
  cursor: pointer;
  transition: all $transition-fast;
  
  &:hover {
    background: white;
    color: $primary-color;
    padding-left: 28px;
    
    .topic-action img {
      opacity: 1;
    }
  }
  
  .topic-number {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: rgba($primary-color, 0.1);
    color: $primary-color;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 600;
    flex-shrink: 0;
  }
  
  .topic-name {
    flex: 1;
  }
  
  .topic-action img {
    width: 14px;
    height: 14px;
    opacity: 0.5;
    flex-shrink: 0;
  }
}

.action-buttons {
  position: absolute;
  bottom: 24px;
  right: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 100;
}

.status-indicator {
  .status-icon {
    width: 28px;
    height: 28px;
    
    &.success {
      filter: drop-shadow(0 0 4px rgba($success-color, 0.5));
    }
    
    &.error {
      filter: drop-shadow(0 0 4px rgba($danger-color, 0.5));
    }
  }
}

.btn-run {
  min-width: 100px;
}

.btn-outline {
  background: transparent;
  border: 1px solid $border-color;
  color: $text-secondary;
  
  &:hover {
    border-color: $primary-color;
    color: $primary-color;
  }
}

.error-layer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 60%;
  height: 180px;
  background: #fef2f2;
  border-top: 1px solid $danger-color;
  padding: 20px;
  color: $danger-color;
  font-family: $font-family-mono;
  font-size: 13px;
  overflow: auto;
  z-index: 50;
  
  @include scroll-style;
}
</style>
